import { Navbar, Nav, Container, Button } from "react-bootstrap";
import { NavLink, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

export default function AppNavbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("token"));

  useEffect(() => {
    setIsLoggedIn(!!localStorage.getItem("token"));
  }, [location]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    setIsLoggedIn(false);
    navigate("/login");
  };

  const loggedInLinks = ["Dashboard", "Registry", "Purchase"];
  const loggedOutLinks = ["Home"];

  return (
    <Navbar expand="lg" sticky="top" className="bg-light shadow-sm">
      <Container>
        <motion.div
          initial={{ x: -200, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ type: "spring", stiffness: 120 }}
        >
          <Navbar.Brand as={NavLink} to="/" className="fw-bold fs-4 text-primary">
            Momentary ✨
          </Navbar.Brand>
        </motion.div>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-center">
            {(isLoggedIn ? loggedInLinks : loggedOutLinks).map((item) => (
              <motion.div key={item} whileHover={{ scale: 1.1, color: "#10b981" }}>
                <Nav.Link
                  as={NavLink}
                  to={item === "Home" ? "/" : `/${item.toLowerCase()}`}
                  className="px-2"
                >
                  {item}
                </Nav.Link>
              </motion.div>
            ))}

            {isLoggedIn ? (
              <motion.div whileHover={{ scale: 1.05, rotate: 3 }}>
                <Button onClick={handleLogout} variant="danger" className="ms-3">
                  Logout
                </Button>
              </motion.div>
            ) : (
              <motion.div whileHover={{ scale: 1.05, rotate: 3 }}>
                <Button as={NavLink} to="/login" variant="primary" className="ms-3">
                  Login
                </Button>
              </motion.div>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
